import { render, staticRenderFns } from "./PrazoRegularizar.vue?vue&type=template&id=606d56f6&lang=pug&"
import script from "./PrazoRegularizar.vue?vue&type=script&lang=js&"
export * from "./PrazoRegularizar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports